var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99911 7.27988L1.68578 4.96655C1.42578 4.70655 1.00578 4.70655 0.745781 4.96655C0.485781 5.22655 0.485781 5.64655 0.745781 5.90655L3.53245 8.69322C3.79245 8.95322 4.21245 8.95322 4.47245 8.69322L11.5258 1.63988C11.7858 1.37988 11.7858 0.959883 11.5258 0.699883C11.2658 0.439883 10.8458 0.439883 10.5858 0.699883L3.99911 7.27988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ef67a318a31ad99528bc2ad5944b060a.svg";
export { ForwardRef as ReactComponent };